"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exists = exports.exists = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isString_1 = __importDefault(require("lodash/isString"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function exists(value, args, constraints) {
    const shouldValidate = await (0, mol_validator_utils_1.evaluateBaseConstraints)(value, args, constraints);
    if (!shouldValidate) {
        return { pass: true, skipped: true };
    }
    if ((0, isNil_1.default)(value)) {
        return { pass: false, message: `should not be missing` };
    }
    if ((0, isString_1.default)(value) && !!(constraints === null || constraints === void 0 ? void 0 : constraints.allowEmptyString) === false && (0, isEmpty_1.default)(value)) {
        return { pass: false, message: `should not be empty` };
    }
    return { pass: true };
}
exports.exists = exists;
/**
 * Validates that the value is not nil or an empty string
 */
function Exists(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "Exists",
        defaultMessage: "should exist",
        options,
        constraints,
        validateFn: exists,
    });
}
exports.Exists = Exists;
//# sourceMappingURL=Exists.js.map